/* @ngInject */
const wagonIdCtrl = (
  $scope,
  $uibModalInstance,
  toaster,
  labels,
  wagonUtils,
  valueHandler,
  types,
  matcher
) => {
  const ID_LENGTH = 12

  $scope.inputOptions = {
    label: 'Numéro wagon',
    icon: 'train',
    type: types.incompleteWagonId,
  }

  const init = () => {
    $scope.formattedId = Array(ID_LENGTH + 4).fill(null)
    $scope.formattedId[2] = '-'
    $scope.formattedId[5] = '-'
    $scope.formattedId[9] = '-'
    $scope.formattedId[14] = '-'
    $scope.isValid = false
    $scope.idNumbers = Array(ID_LENGTH).fill(null)
    $scope.missingNumber = null
  }

  init()

  $scope.init = () => {
    init()
    $scope.id = null
  }

  $scope.isNumber = valueHandler.isNumber

  $scope.$watch('id', (newId, oldId) => {
    if (!valueHandler.isEmpty(newId) && newId !== oldId) {
      const numberId = numberise(newId.split(''))
      const missingIndex = getMissingIndex(numberId)
      let missingNumber = null
      if (missingIndex >= 0) {
        missingNumber = findMissingNumber(numberId, missingIndex)
      } else {

      }
      $scope.formattedId = formatResult(numberId)
      $scope.missingNumber = missingNumber
      $scope.missingIndex = missingIndex
      if (wagonUtils.isIdValid(newId)) {
        $scope.isValid = true
      } else {
        $scope.isValid = false
      }
    }
  })

  const formatResult = (id) => {
    const res = []
    for (let i = 0; i < ID_LENGTH; i++) {
      if (i === 2 || i === 4 || i === 7 || i === 11) {
        res.push('-')
      }

      res.push(id[i])
    }
    return res
  }

  const numberise = (textArray) => {
    return textArray.map((char) => {
      if (matcher.contain(char, '[0-9]')) {
        return parseInt(char)
      } else {
        return null
      }
    })
  }

  const findMissingNumber = (numberId, missingIndex) => {
    let tempId = ''
    if (missingIndex === 11) {
      for (let index = 0; index < ID_LENGTH - 1; index++) {
        tempId += numberId[index]
      }
      return wagonUtils.autocontrole(tempId)
    } else {
      for (let potentialNumber = 0; potentialNumber < 10; potentialNumber++) {
        tempId = ''
        for (let index = 0; index < ID_LENGTH - 1; index++) {
          if (index === missingIndex) {
            tempId += potentialNumber
          } else {
            tempId += numberId[index]
          }
        }
        const tempAutocontrole = wagonUtils.autocontrole(tempId)
        if (valueHandler.isNotNull(tempAutocontrole)
          && tempAutocontrole === numberId[ID_LENGTH - 1]) {
          return potentialNumber
        }
      }
    }
  }

  const getMissingIndex = (ids) => {
    let missingArguments = 0
    let missingIndex = -1
    for (let i = 0; i < ID_LENGTH; i++) {
      if (!valueHandler.isNumber(ids[i])) {
        missingArguments++
        missingIndex = i
      }
      if (missingArguments > 1) {
        return -1
      }
    }
    return missingIndex
  }

  $scope.close = () => {
    $uibModalInstance.close()
  }

  $scope.alertCopy = (_id) => {
    if (!$scope.idIalid) {
      toaster.message(labels.copied)
    } else {
      toaster.message(labels.wagon.fields.id.messages.invalid)
    }
  }

  var input
  setTimeout(() => {
    input = document.getElementById('input')
    input.onpaste = cleanIdPaste
  })

  const cleanIdPaste = (e) => {
    e.preventDefault()
    e.stopPropagation()
    let pastedText = ''

    if (e.clipboardData && e.clipboardData.getData) {
      pastedText = e.clipboardData.getData('text/plain')
    } else if (window.clipboardData && window.clipboardData.getData) {
      pastedText = window.clipboardData.getData('Text')
    }

    const trimText = pastedText.toString().replace(/ /g, '').replace(/-/g, '')
    if (matcher.contain(trimText, '[0-9]')) {
      $scope.id = trimText
      $scope.$apply()
    }
  }
}

export default wagonIdCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/menus/wagonId.controller.js